import { render, staticRenderFns } from "./ProductParametersBundle.vue?vue&type=template&id=1c5aacf2&"
import script from "./ProductParametersBundle.vue?vue&type=script&lang=js&"
export * from "./ProductParametersBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports